<template>
  <div>
    <ul class="nav nav-tabs delivery-requests-nav-tabs" id="delivery-requests-tabs">
      <li v-for="item in navTabs" :key="item.id" :id="item.id" :class="activeTab(item.id)" @click="changeTab(item.id)">
        <a>{{ item.name }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import tabs from '@/common/delivery-tabs'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    tab: {
      type: String,
      default: 'top'
    },
    hasWarehouseUsing: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      navTabs: tabs
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUser'
    })
  },
  methods: {
    activeTab (tabName) {
      let canIsInvalidTabs = ['top', 'delivery-request-list', 'delivery-request-registration']
      if (!this.hasWarehouseUsing && canIsInvalidTabs.includes(tabName)) {
        return 'invalid-tab'
      }
      if (tabName === 'delivery-request-registration' && this.tab === 'update-delivery-request-registration') {
        return 'active'
      }
      return this.tab === tabName ? 'active' : ''
    },
    changeTab (tabName) {
      if (tabName === 'delivery-request-registration' && this.tab === 'update-delivery-request-registration') {
        return
      }
      let availableTabs = ['top', 'delivery-request-list', 'delivery-request-registration', 'expense-detail-actual-shipment', 'expense-detail-storage-fee', 'receive-amount-diff-setting']
      if (availableTabs.includes(tabName)) {
        let tabsParamsName = {
          top: eventCode.delivery_requests.top_tab.show,
          delivery_request_list: eventCode.delivery_requests.delivery_request_list_tab.show,
          delivery_request_registration: eventCode.delivery_requests.delivery_request_registration_tab.show,
          expense_detail_actual_shipment: eventCode.delivery_requests.expense_detail_actual_shipment_tab.show,
          expense_detail_storage_fee: eventCode.delivery_requests.expense_detail_storage_fee_tab.show,
          usage_plan_management: eventCode.delivery_requests.usage_plan_management_tab.show
        }

        let tabKey = tabName.replaceAll('-', '_')
        let logParams = {
          name: tabsParamsName[tabKey],
          properties: {}
        }
        EventService.postTrackLog(logParams)

        setTimeout(() => {
          $(`#${tabName}`).addClass('disabled-tab')
        }, 100)
      }
      this.$router.push(`/delivery-requests/${tabName}`)
    }
  },
  mounted () {
    if (this.tab === 'update-delivery-request-registration') {
      $(`#delivery-request-registration`).addClass('disabled-tab')
    } else {
      $(`#${this.tab}`).addClass('disabled-tab')
    }
  }
}
</script>

<style scoped>
.disabled-tab {
  pointer-events: none;
}
.invalid-tab {
  pointer-events: none;
}
.invalid-tab a {
  color: #bfbfbf;
}
</style>



// WEBPACK FOOTER //
// src/view/deliveryRequests/NavTabs.vue